import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError as observableThrowError, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../environments/environment';

@Injectable()
export class AdminService {
  private hostPath: string = JSON.parse(environment.IDENTITY);

  constructor(public router: Router, private authHttp: HttpClient, private http: HttpClient) {
  }

  // To update user data / user profile based on particular userId
  public updateUserDate(user): Observable<any> {
    // const data = {site: 'www.shuttlebuss.se', user};
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.authHttp
      .post<any>(this.hostPath + 'Shuttlebuss/Shuttlebuss.Service/User/updateuser', user, {
        headers
      })
      .pipe(
        map((result: any) => result),
        catchError(this.handleError)
      );
  }

  private handleError(error: Response | any) {
    const errMsg = error.message
      ? error.message
      : error.status
      ? `${error.status} - ${error.statusText}`
      : 'Server error';
    console.error('admin.service - Handled error: ' + errMsg); // log to console for now
    return error;
    // Todo: How to handle this properly in component?
  }
}